var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscardedTagIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 21.8936,
    height: 22.5,
    viewBox: "0 0 21.8936 22.5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "discarded-applicant-icon 1",
    clipPath: "url(#clip0_0_4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.9468 22.5C16.9926 22.5 21.8936 17.4632 21.8936 11.25C21.8936 5.0368 16.9926 0 10.9468 0C4.90105 0 0 5.0368 0 11.25C0 17.4632 4.90105 22.5 10.9468 22.5Z",
    fill: "#F5F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.7782 4.5H7.11543C6.51085 4.5 6.02074 5.00368 6.02074 5.625V16.3125C6.02074 16.9338 6.51085 17.4375 7.11543 17.4375H14.7782C15.3828 17.4375 15.8729 16.9338 15.8729 16.3125V5.625C15.8729 5.00368 15.3828 4.5 14.7782 4.5Z",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.9468 10.125C11.8537 10.125 12.5888 9.36948 12.5888 8.4375C12.5888 7.50552 11.8537 6.75 10.9468 6.75C10.0399 6.75 9.30479 7.50552 9.30479 8.4375C9.30479 9.36948 10.0399 10.125 10.9468 10.125Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.66277 15.75C7.66277 13.5754 9.13309 11.8125 10.9468 11.8125C12.7605 11.8125 14.2309 13.5754 14.2309 15.75",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15.3255 18.5625C17.1393 18.5625 18.6096 17.0515 18.6096 15.1875C18.6096 13.3235 17.1393 11.8125 15.3255 11.8125C13.5118 11.8125 12.0415 13.3235 12.0415 15.1875C12.0415 17.0515 13.5118 18.5625 15.3255 18.5625Z",
    fill: "#F5F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M13.9572 13.7813L16.6939 16.5938",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M16.6939 13.7813L13.9572 16.5938",
    stroke: "currentColor",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.8936,
    height: 22.5,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscardedTagIcon);
export default __webpack_public_path__ + "static/media/DiscardedTagIcon.8f8ea60fd74b4dd823750bd1dd8a59a1.svg";
export { ForwardRef as ReactComponent };